/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import { Dropdown } from 'framework/form';

const AssetAssignmentFilter = (props: any) => {
  return (
    <DropDownFilter {...props} isSingle>
      <Dropdown
        options={[
          {
            label: 'Yes',
            value: 'YES',
          },
          {
            label: 'No',
            value: 'NO',
          },
        ]}
        {...props}
      />
    </DropDownFilter>
  );
};

export default AssetAssignmentFilter;
